import abl from '../abl';
import GoogleAPI from './google/google_api';
import AuthAPI from './auth_api';
import ScheduleAPI from './schedule_api';
import MockAPI from './mock/mock_api';

const requestor = abl.config.use_fixtures ? new MockAPI() : new GoogleAPI();

const clients = {
  auth: new AuthAPI({requestor: requestor}),
  schedule: new ScheduleAPI({requestor: requestor})
};

export default clients;


/** WEBPACK FOOTER **
 ** ./src/js/clients/clients.js
 **/